/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: X8JAhBnvVOdu
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import Op1WebButtonAppWindow from "../../OP1WebButtonAppWindow"; // plasmic-import: BXxrqEh84nVD/codeComponent
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicButonulCareDeschideOFereastraTest.module.css"; // plasmic-import: X8JAhBnvVOdu/css

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicButonulCareDeschideOFereastraTest__VariantProps =
  new Array();

export const PlasmicButonulCareDeschideOFereastraTest__ArgProps = new Array();

const $$ = {};

function PlasmicButonulCareDeschideOFereastraTest__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "appWindowButton.isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton.isFocused",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton.state",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_nJ1Nn58LcfAm7wemZm71QH",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.root
          )}
        >
          <h1
            data-plasmic-name={"h1"}
            data-plasmic-override={overrides.h1}
            className={classNames(
              "all",
              "h1",
              "h1__nJ1Nn",
              "__wab_text",
              sty.h1
            )}
          >
            {"Desktop Persistence Text Trigger Test"}
          </h1>
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames("all", "__wab_text", sty.text)}
          >
            {
              "This page has its own content, separate from the dock. Click the link below to open a floating window - it stays open and keeps its position even when you navigate to another page."
            }
          </div>
          <Op1WebButtonAppWindow
            data-plasmic-name={"appWindowButton"}
            data-plasmic-override={overrides.appWindowButton}
            className={classNames("__wab_instance", sty.appWindowButton)}
            onFocusedChange={async (...eventArgs) => {
              generateStateOnChangeProp($state, [
                "appWindowButton",
                "isFocused"
              ]).apply(null, eventArgs);
            }}
            onOpenChange={async (...eventArgs) => {
              generateStateOnChangeProp($state, [
                "appWindowButton",
                "isOpen"
              ]).apply(null, eventArgs);
            }}
            onStateChange={async (...eventArgs) => {
              generateStateOnChangeProp($state, [
                "appWindowButton",
                "state"
              ]).apply(null, eventArgs);
            }}
            windowId={"textTest"}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "h1", "text", "appWindowButton"],
  h1: ["h1"],
  text: ["text"],
  appWindowButton: ["appWindowButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames:
            PlasmicButonulCareDeschideOFereastraTest__ArgProps,
          internalVariantPropNames:
            PlasmicButonulCareDeschideOFereastraTest__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButonulCareDeschideOFereastraTest__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicButonulCareDeschideOFereastraTest";
  } else {
    func.displayName = `PlasmicButonulCareDeschideOFereastraTest.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "nJ1Nn58LcfAm7wemZm71QH"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicButonulCareDeschideOFereastraTest = Object.assign(
  // Top-level PlasmicButonulCareDeschideOFereastraTest renders the root element
  withUsePlasmicAuth(makeNodeComponent("root")),
  {
    // Helper components rendering sub-elements
    h1: makeNodeComponent("h1"),
    text: makeNodeComponent("text"),
    appWindowButton: makeNodeComponent("appWindowButton"),
    // Metadata about props expected for PlasmicButonulCareDeschideOFereastraTest
    internalVariantProps:
      PlasmicButonulCareDeschideOFereastraTest__VariantProps,
    internalArgProps: PlasmicButonulCareDeschideOFereastraTest__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/butonul-care-deschide-o-fereastra-test",
      pagePath: "/butonul-care-deschide-o-fereastra-test",
      params: {},
      query: {}
    })
  }
);

export default PlasmicButonulCareDeschideOFereastraTest;
/* prettier-ignore-end */
